import RiddleCard from "../components/riddle/riddle";

export default function RiddlesPage() {
  return <RiddleCard page/>;
}